import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Autocomplete, Icon } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons'
import debounce from 'lodash/debounce';

import axios from '@utils/axios';

const propTypes = {
  apiURL: PropTypes.string,
  onSelectionCallback: PropTypes.func.isRequired,
  onClearCallback: PropTypes.func,

  label: PropTypes.string,
  placeholder: PropTypes.string,

  itemLabelAccessor: PropTypes.string, // if different from 'label', i.e. "title", "name", etc
  itemValueAccessor: PropTypes.string, // if different from 'value', i.e. "id", "name", etc.
  filterOptions: PropTypes.array, // If gonna initialize options
  searchDelay: PropTypes.number, // Miliseconds
}

const defaultProps = {
  itemLabelAccessor: "label",
  itemValueAccessor: "value",
  placeholder: "Buscar...",
  filterOptions: [],
  searchDelay: 1000,
}

const AutocompleteSearch = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]); // Selected options
  const [options, setOptions] = useState(props.filterOptions); // Dropdown options
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchItems = async (value) => {
    if(!loading){
      setLoading(true);
    }
    if(value == ""){ // Clear query
      !!props.apiURL ? setOptions([]) : setOptions(props.filterOptions);
      setLoading(false);
      return;
    }

    if (props.apiURL){
      try {
        const response = await axios.post(props.apiURL, { query: value } );
        const { data } = response;
        if(data){
          const parsedItems = data.items.map( (item) => ({ label: item[props.itemLabelAccessor], value: item[props.itemValueAccessor], data: item }) )
          setOptions(parsedItems);
        }
      } catch (error) {
        console.log(error);
        alert("Ocurrio un error de conexión.")
      }
    }else { // if no API just search among options
      const filterRegex = new RegExp(value, 'i');
      const resultOptions = options.filter((option) =>
          option.label.match(filterRegex),
      );
      setOptions(resultOptions);
    }

    setLoading(false);
  }
  const fetchItemsDebounced = useCallback( debounce(fetchItems, props.searchDelay), []);
  const clearSearch = () => {
    setInputValue("");
    fetchItemsDebounced("");
    props.onClearCallback();
  }

  const updateText = (value) => {
    setInputValue(value);
    fetchItemsDebounced(value); // Debounce fetch API
  }

  const updateSelection = (selectedValue) => {
    setSelectedOptions(selectedValue);
    const selectedOption = options.find( (option) => option.value == selectedValue );
    setInputValue(selectedOption.label);

    props.onSelectionCallback(selectedValue, selectedOption.data); // Some options got extra data, else it will be just null
  }

  const textField = (
    <Autocomplete.TextField
      onChange={updateText}
      label={ props.label }
      value={inputValue}
      prefix={<Icon source={SearchMinor} color="base" />}
      placeholder={ props.placeholder }
      clearButton={ !!props.onClearCallback }
      onClearButtonClick={ clearSearch }
    />
  );

  return (
    <Autocomplete
      options={options}
      selected={selectedOptions}
      onSelect={updateSelection}
      loading={loading}
      textField={textField}
      allowMultiple={false}
    />
  );
};

AutocompleteSearch.propTypes = propTypes;
AutocompleteSearch.defaultProps = defaultProps;

export default AutocompleteSearch;